import { render, staticRenderFns } from "./token.vue?vue&type=template&id=8e527616&scoped=true&"
import script from "./token.vue?vue&type=script&lang=js&"
export * from "./token.vue?vue&type=script&lang=js&"
import style0 from "./token.vue?vue&type=style&index=0&id=8e527616&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e527616",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8e527616')) {
      api.createRecord('8e527616', component.options)
    } else {
      api.reload('8e527616', component.options)
    }
    module.hot.accept("./token.vue?vue&type=template&id=8e527616&scoped=true&", function () {
      api.rerender('8e527616', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/wallet/conversion/token.vue"
export default component.exports